import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PartnerService } from '../../../../../services/partner.service';
import { PaymentService } from '../../../../../services/payment.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AddEditUserV2Component } from 'src/app/components/modals/add-edit-user-v2/add-edit-user-v2.component';
import { MessageService } from 'primeng/api';
import { UserEditComponent } from 'src/app/components/modals/user-edit/user-edit.component';

@Component({
  selector: 'app-staff',
  templateUrl: './staff.component.html',
  styleUrls: ['./staff.component.scss'],
})
export class StaffComponent implements OnInit {
  @Input() users;
  @Input() isWorkshop = true;
  @Input() isRentals = false;
  @Output() getUsers = new EventEmitter();
  @Input() messageService: MessageService;
  @Input() loading;
  public partnerID: string;
  public techniciansAllowed = null;
  public technicians: any = [];
  public canAddStaff = false;
  public columns: any = [
    {
      header: this.translate.instant('general.headers.firstname'),
      field: 'Name',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.surname'),
      field: 'Surname',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.email'),
      field: 'Email',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.system_view'),
      field: 'TechnicianID',
      type: 'technician',
    },
    {
      header: this.translate.instant('general.headers.technician_status'),
      field: 'IsActive',
      type: 'technician_status',
    },
  ];
  public profile: any;
  public roles = [
    { id: 1, role: 'Technician' },
    { id: 2, role: 'Admin' },
    { id: 3, role: 'Workshop Manager' },
    { id: 4, role: 'Fitter' },
    { id: 5, role: 'RAW Admin' },
    { id: 6, role: 'RAW Employee' },
    { id: 7, role: 'Insurer' },
    { id: 8, role: 'Bikeshop Claims Admin' },
    { id: 9, role: 'Service Lead' },
    { id: 10, role: 'Shop Ride Admin' }
  ];

  constructor(
    public partnerService: PartnerService,
    public helpersService: HelpersService,
    public modalService: NgbModal,
    private translate: TranslateService,
    private paymentService: PaymentService,
  ) {
    this.partnerID = this.helpersService.getPartnerId();
    this.paymentService.getPaymentStatus(this.partnerID).subscribe((res) => {
      this.techniciansAllowed = res.techniciansAllowed;
    });
  }

  ngOnInit() {
    this.profile = this.helpersService.getProfileData();

    this.canAddStaff = 
      this.profile.UserRoles.filter((x) => { return x.PartnerID === this.partnerID; }).map((x) => { return x.RoleID;}).indexOf(2) > -1 ||      
      this.profile.UserRoles.filter((x) => { return x.PartnerID === this.partnerID; }).map((x) => { return x.RoleID;}).indexOf(3) > -1 ||      
      this.profile.IsSuperUser;

  }

  ngOnChanges(changes): void {
    if (!this.isWorkshop) {
      
      this.users = this.users.filter((x) => {
        return (
          x.UserRoles.map((y) => {
            return y.RoleID;
          }).indexOf(2) > -1
        );
      });
    }
  }

  getRole(role) {
    var r = this.roles
      .filter((x) => {
        return x.id === role.RoleID;
      })
      .pop();
    return r ? r.role : 'N/A';
  }

  newStaff() {
    var allocatedTechnicians = this.users.filter((x) => {
      return (
        x.UserRoles.filter((y) => {
          return y.RoleID === 1 || y.RoleID === 4;
        }).length > 0
      );
    }).length;
    const modalRef = this.modalService.open(AddEditUserV2Component, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'user-modal',
    });
    modalRef.componentInstance.messageService = this.messageService;
    modalRef.componentInstance.techniciansAllowed = this.techniciansAllowed;
    modalRef.componentInstance.allocatedTechnicians = allocatedTechnicians;
    modalRef.componentInstance.isWorkshop = this.isWorkshop;
    modalRef.componentInstance.isRentals = this.isRentals;
    modalRef.result.then(
      (result) => {
        this.getUsers.emit();
      },
      (onrejected) => {
        this.getUsers.emit();
      },
    );
  }

  editStaff(user) {
    var allocatedTechnicians = this.users.filter((x) => {
      return (
        x.UserRoles.filter((y) => {
          return y.RoleID === 1;
        }).length > 0
      );
    }).length;
    const modalRef = this.modalService.open(UserEditComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'user-modal',
    });
    modalRef.componentInstance.user = user;
    modalRef.componentInstance.messageService = this.messageService;
    modalRef.componentInstance.techniciansAllowed = this.techniciansAllowed;
    modalRef.componentInstance.allocatedTechnicians = allocatedTechnicians;
    modalRef.componentInstance.isWorkshop = this.isWorkshop;
    modalRef.componentInstance.isRentals = this.isRentals;
    modalRef.result.then(
      (result) => {
        this.getUsers.emit();
      },
      (onrejected) => {
        this.getUsers.emit();
      },
    );
  }

  hashCode(str) {
    var hash = 0;
    if (str) {
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
    }
    return hash;
  }

  intToRGB(i) {
    var c = (i & 0x00ffffff).toString(16).toUpperCase();
    return '00000'.substring(0, 6 - c.length) + c;
  }
}
